// extracted by mini-css-extract-plugin
export default {"container":"Sa8ja5Xza_D8AGxBE1W6","label":"co4f82pzhBRpLeaF2iEQ","contextCopy":"DOL5dNYRtPI_JZDSbxW6","textareaWrapper":"yAl_Jr3GwQkmS0C8wJEo","pulse":"dPPCireBL8lmjOexbFgZ"};